export const apiEnv: any = {
  development: {
    baseUrl: "https://salback.shop",
    authSubsUrl: "https://auth-subs.salback.shop/v1",
    mediaUrl: "https://saladmin.smartsway.com:3000",
  },
  production: {
    baseUrl: "https://salapi.smartsway.com",
    authSubsUrl: "https://auth-subs.smartsway.com/v1",
    mediaUrl: "https://saladmin.smartsway.com:3000",
  },
};
export const redesignYourLifeLink = {
  url: process.env.REACT_APP_REDESIGN_YOUR_LIFE_LINK || "",
};

const appEnv = process.env.REACT_APP_ENV || "development";
export let BASE_URL: any = apiEnv[appEnv].baseUrl;
export let baseURL: any = apiEnv[appEnv].baseUrl;
export let AUTH_SUBS_BASE_URL: string =
  process.env.REACT_APP_AUTH_SUBS_URL || apiEnv[appEnv].authSubsUrl;
export let MEDIA_URL: any = apiEnv[appEnv].mediaUrl;
export let BASE_MEDIA: any = apiEnv[appEnv].mediaUrl;
